import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react';

/* Interfaces */
import { PaymentType, PaymentTypesReversed } from '../interfaces/payment_types';

interface PaymentTypeContent {
  selectedPayment: PaymentType | undefined;
  setSelectedPayment: (payment: PaymentType) => void;

  paymentHandler: any;
  setPaymentHandler: (handler: any) => void;

  options: any;
  setOptions: (option: any) => void;
}

export const PaymentTypeContext = createContext<PaymentTypeContent>({
  selectedPayment: PaymentTypesReversed.Stripe,
  setSelectedPayment: () => ({}),

  paymentHandler: {},
  setPaymentHandler: () => ({}),

  options: {},
  setOptions: () => ({}),
});

export const PaymentTypeProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [selectedPayment, setSelectedPayment] = useState<
    PaymentType | undefined
  >(undefined);
  const [paymentHandler, setPaymentHandler] = useState<any>({});
  const [options, setOptions] = useState<any>({});

  const value = {
    selectedPayment,
    setSelectedPayment,
    paymentHandler,
    setPaymentHandler,
    options,
    setOptions,
  };

  return (
    <PaymentTypeContext.Provider value={value}>
      {children}
    </PaymentTypeContext.Provider>
  );
};

export const usePaymentTypeContext = () => useContext(PaymentTypeContext);
